import { z } from 'zod';

export const booleanOperators = z.enum(['eq', 'null', 'notnull']);

export const datetimeOperators = z.enum(['eq', 'null', 'notnull', 'gt', 'lt', 'in']);

export const picklistOperators = z.enum(['eq', 'in', 'null', 'notnull']);

export const stringOperators = z.enum([
  'eq',
  'in',
  'ne',
  'containsIgnoreCase',
  'startsWithIgnoreCase',
]);

export type DateOperator = z.infer<typeof datetimeOperators>;
export type PicklistOperator = z.infer<typeof picklistOperators>;
export type StringOperator = z.infer<typeof stringOperators>;
export type BooleanOperator = z.infer<typeof booleanOperators>;
